import React from 'react';
import { FaExclamationCircle } from 'react-icons/fa';

import './forms.css';

export const renderField = ({ classname, input, label, meta: { active, error, touched }, ...rest }) => {
  const err = error ? ' error' : '';
  const errIcon = err ? <FaExclamationCircle className="error-icon" /> : null;
  const labelId = Math.random() * 100000;
  return (
    <div className={classname}>
      <label className={`${input.name}-label label`} htmlFor={`input-${labelId}`}>
        {label}
      </label>
      <input
        id={`input-${labelId}`}
        className={`${input.name}-input input${!active && touched && err}`}
        {...input}
        {...rest}
        aria-invalid={!!(touched && error)}
      />
      <div className="error-container" aria-live="polite" aria-atomic="true" aria-describedby={`input-${labelId}`}>
        {touched && !active && errIcon}
        <span className={`${err}`}>{touched && error}</span>
      </div>
    </div>
  );
};
